<template>
  <svg class="stroke-current w-8 h-8 mr-1 md:mr-3" viewBox="0 0 28.55 41.25" xmlns="http://www.w3.org/2000/svg"><g fill="none" stroke-linejoin="round"><path d="m8.21 20.3 4.4 4.39 8.16-8.16"/><path d="m26.49 5.83a16.2 16.2 0 0 1 -10.73-4.07l-1.48-1.26-1.46 1.29a16.2 16.2 0 0 1 -10.76 4h-1.56v17.88c0 13 13.78 17.08 13.78 17.08s13.77-4.11 13.77-17.08v-17.84z"/><path d="m14.28 36.61s10.72-3.2 10.72-13.3"/><path d="m9.24 8.58a12.48 12.48 0 0 1 -4.48.83h-1.21v6.66"/></g></svg>
</template>

<script>
export default {

};
</script>

<style>

</style>
